import { News } from './news';

export const NewsItems: News[] = [
  {
    date: "09/02/2023",
    title: "Four Double Bills",
    text: "The new dates for the performances of 'A Double Bill of Cuthbert Masterstroke' have been set as the 26th-29th April 2023. Cuthbert would like to thank you all for your patience, and thank himself for solving this mystery, even though it wasn't actually a mystery. He would also like you to come along and take a seat, so please, take a look at the details below and book a ticket!"
  }
]
